// extracted by mini-css-extract-plugin
export default {"files_wrapper":"CreateOrEditModelModal_files_wrapper__HR4Ce","label_seat":"CreateOrEditModelModal_label_seat__DS1WT","required":"CreateOrEditModelModal_required__SVka7"};